/**
 * Modal script
 */
import ui from '../ui';

let initializeContainer = function($container) {
    let defaultCallbacks = {
        open: function() {
            let $html = $(this.content);
            $html.find('.CodeMirror').each(function(i, el) {
                el.CodeMirror.refresh();
            });
        },
    };

    $container.find('.modal-basic').magnificPopup({
        type:      'inline',
        preloader: false,
        modal:     true,
        callbacks: defaultCallbacks,
    });

    $container.find('.modal-with-zoom-anim:not(.modal-ajax)').magnificPopup({
        type:            'inline',
        fixedContentPos: false,
        fixedBgPos:      true,
        overflowY:       'auto',
        closeBtnInside:  true,
        preloader:       false,
        midClick:        true,
        removalDelay:    300,
        mainClass:       'my-mfp-zoom-in',
        modal:           true,
        callbacks:       defaultCallbacks,
    });

    $container.find('.modal-with-zoom-anim.modal-ajax').magnificPopup({
        type:            'ajax',
        fixedContentPos: false,
        fixedBgPos:      true,
        overflowY:       'auto',
        closeBtnInside:  true,
        preloader:       false,
        midClick:        true,
        removalDelay:    300,
        mainClass:       'my-mfp-zoom-in',
        modal:           true,
        callbacks:       $.extend(defaultCallbacks, {
            ajaxContentAdded: function() {
                ui.initializeContainer(this.content);
            },
        }),
    });

    $container.find('.modal-with-move-anim').magnificPopup({
        type:            'inline',
        fixedContentPos: false,
        fixedBgPos:      true,
        overflowY:       'auto',
        closeBtnInside:  true,
        preloader:       false,
        midClick:        true,
        removalDelay:    300,
        mainClass:       'my-mfp-slide-bottom',
        modal:           true,
        callbacks:       defaultCallbacks,
    });

    $container.find('.modal-image-zoom, .modal-image-zoom-registration').magnificPopup({
        type:                'image',
        closeOnContentClick: true,
        closeBtnInside:      false,
        fixedContentPos:     true,
        mainClass:           'mfp-no-margins mfp-with-zoom', // class to remove default margin from left and right side
        image:               {
            verticalFit: true
        },
        zoom:                {
            enabled:  true,
            duration: 300,
        },
        callbacks:           defaultCallbacks,
    });
};

// Export initialization
export default {
    initializeContainer: initializeContainer,
    initialize:          function() {
        // Modal dismissal links
        $(document).on('click', '.modal-dismiss', function(e) {
            e.preventDefault();
            $.magnificPopup.close();
        });
    },
    closeAll:            function() {
        $.magnificPopup.close();
    },
};



// WEBPACK FOOTER //
// ./plugins/Admin/build/script/src/ui/modal.js